'use client';
export const DEBUG = process.env.NEXT_PUBLIC_DEBUG === 'true' ||
    process.env.REACT_APP_DEBUG === 'true' ||
    process.env.DEBUG === 'true';
export class Logger {
    static log(...args) {
        DEBUG && console.log(...args);
    }
    static error(...args) {
        DEBUG && console.error(...args);
    }
}
